// import {Box, Button, Container, Grid, Paper} from '@mui/material';
import {Box, Container, Grid} from '@mui/material';
import React, {useEffect, useState} from 'react';
import POCToolSummaryTableItem from './POCToolSummaryTableItem';
import {loadPOCToolSummaries} from '../../../api/POCCMSPortalAPI/pointOfCareTools/POCToolsCalls';
import HomeHeaderBar from './HomeHeaderBar';
import {useNavigate} from 'react-router-dom';
import {sortSummaries} from '../../../Util/sorter';

export default function POCtoolsCMSHome() {
  const navigate = useNavigate();

  const [summaries, setSummaries] = useState([]);
  const [sortedBy, setSortedBy] = useState('name');

  useEffect(() => {
    loadPOCToolSummaries()
      .then(res => setSummaries(res))
      .catch(err => {
        err === 401 && navigate('/Login');
      });
  }, []);

  //TODO: Change ▼ to icon. Add toggle between low to high and high to low
  return (
    <Container style={styles.container}>
      <Box style={styles.innerContainer}>
        <HomeHeaderBar />
        <Box mt={5} p={1}>
          <Box style={styles.columnContainer}>
            <Grid container>
              <Grid
                item
                xs={3}
                sm={3}
                md={3}
                lg={3}
                onClick={() => setSortedBy('name')}>
                <span>Name</span>
                {sortedBy === 'name' && <span>▼</span>}
              </Grid>
              <Grid
                item
                xs={1.5}
                sm={1.5}
                md={1.5}
                lg={1.5}
                onClick={() => setSortedBy('status')}>
                <span>Status</span>
                {sortedBy === 'status' && <span>▼</span>}
              </Grid>
              <Grid
                item
                xs={1.5}
                sm={1.5}
                md={1.5}
                lg={1.5}
                onClick={() => setSortedBy('publishDate')}>
                <span>Publish Date</span>
                {sortedBy === 'publishDate' && <span>▼</span>}
              </Grid>
              <Grid
                item
                xs={2}
                sm={2}
                md={2}
                lg={2}
                onClick={() => setSortedBy('updatedBy')}>
                <span>Last Updated by</span>
                {sortedBy === 'updatedBy' && <span>▼</span>}
              </Grid>
              <Grid
                item
                xs={1.5}
                sm={1.5}
                md={1.5}
                lg={1.5}
                onClick={() => setSortedBy('lastUpdated')}>
                <span>Last Updated</span>
                {sortedBy === 'lastUpdated' && <span>▼</span>}
              </Grid>
              <Grid
                item
                xs={1.5}
                sm={1.5}
                md={1.5}
                lg={1.5}
                onClick={() => setSortedBy('isSuperPOCTool')}>
                <span>Is SuperPOCTool</span>
                {sortedBy === 'isSuperPOCTool' && <span>▼</span>}
              </Grid>
              <Grid item xs={1} sm={1} md={1} lg={1}>
                <span>Action</span>
              </Grid>
            </Grid>
          </Box>
          {sortSummaries(summaries, sortedBy).map(item => (
            <Box key={item.id} style={styles.summaryContainer}>
              <POCToolSummaryTableItem
                isPublished={item.isPublished}
                lastUpdated={item.lastUpdated}
                publishDate={item.publishDate}
                updatedBy={item.updatedBy}
                isSuperPOCTool={item.isSuperPOCTool}
                name={item.name}
                id={item.id}
              />
            </Box>
          ))}
        </Box>
      </Box>
    </Container>
  );
}

const styles = {
  container: {display: 'flex', justifyContent: 'center', paddingTop: 50},
  innerContainer: {width: '100%'},
  columnContainer: {padding: '30px 24px 0px'},
  summaryContainer: {
    backgroundColor: '#FFFFFF',
    border: '1px solid #DDDDDD',
    borderRadius: 8,
    padding: '20px 20px',
    marginTop: 5,
  },
};
